/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-service-pools-grid';
const prefix = `${moduleName}.${componentName}`;

export const poolGroupsGridLabel = `${prefix}.poolGroupsGridLabel`;
export const algorithmInputLabel = `${prefix}.algorithmInputLabel`;
export const enableCheckboxLabel = `${prefix}.enableCheckboxLabel`;
export const gslbPoolTypeLabel = `${prefix}.gslbPoolTypeLabel`;

export const ENGLISH = {
    [poolGroupsGridLabel]: 'Groups ({0})',
    [algorithmInputLabel]: 'Algorithm',
    [enableCheckboxLabel]: 'Enable',
    [gslbPoolTypeLabel]: 'GSLB Pool Type',
};
